module.exports = __webpack_public_path__ + "img/stephen.8e841201.png";